import { HStack } from "@chakra-ui/react"
import Button from "@pathwright/ui/src/components/button/Button"
import TextInput from "@pathwright/ui/src/components/form/form-text-input/TextInput"
import { useTranslate } from "@pathwright/ui/src/components/lng/withTranslate"
import PropTypes from "prop-types"
import { useState } from "react"
import { isEnterKey } from "../../../utils"

const SubmitLink = ({ onSubmit, disableInput }) => {
  const [link, setLink] = useState("")
  const { t, tc } = useTranslate()

  const isValidLink = (testLink) => {
    if (!testLink) return false
    if (!testLink.match("http")) return false

    return true
  }

  const onSubmitLink = () => {
    setLink("")
    onSubmit(link)
  }

  const handleEnter = (value, event) => {
    if (isEnterKey(event) && isValidLink(link)) onSubmitLink()
  }

  return (
    <HStack width="100%"
    sx={{
      "input[disabled]": {
        opacity: 0.5,
        cursor: "not-allowed",
      },
    }}
    >
      <TextInput
        placeholder={t("Add a URL")}
        onChange={(nextLink) => setLink(nextLink)}
        value={link}
        disabled={disableInput}
        style={{ width: "100%", marginRight: "5px" }}
        onKeyUp={handleEnter}
      />
      <Button
        icon={"add"}
        onClick={onSubmitLink}
        styleType="secondary"
        style={{ width: "auto" }}
        disabled={disableInput || !isValidLink(link)}
      >
        {tc("Submit")}
      </Button>
    </HStack>
  )
}

SubmitLink.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  disableInput: PropTypes.bool
}

export default SubmitLink
